import { useTranslation } from "react-i18next";

export default function PrivacidadeModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h1>{t("privacidade.titulo")}</h1>
        <div className="modal-texto">
          <p>
            {t("privacidade.descricao.p1")}
            <br />
            {t("privacidade.descricao.p2")}
            <br />
            {t("privacidade.descricao.p3")}
            <br />
            {t("privacidade.descricao.p4")}
            <br />
            {t("privacidade.descricao.p5")}
            <br />
            {t("privacidade.descricao.p6")}
            <br />
            {t("privacidade.descricao.p7")}
            <br />
            {t("privacidade.descricao.p8")}
            <br />
          </p>
        </div>
      </div>
    </div>
  );
}
